export let jsonState = [
    {id: 1,
     headline: "Игровая  карта: Количество номеров для ставки",
     text: `Выберите количество номеров на которые Вы хотите сделать свою ставку.
            Вы можете выбрать от 2 до 10 номеров. Стоимость билета не зависит от количества выбранных номеров. 
            Размер Вашего выигрыша зависит от количества выбранных и угаданных номеров (смотрите Таблицу Выигрышей).
            Максимальный выигрыш по одному игровому варианту — 1 000 000 YUSRA.`},

    {id: 2,
     headline: "Карточка: Игровые поля",
     text: `Игровая карта «Кено» содержит 2 игровых поля по 80 номеров в каждом. 
            Зачеркните номера на одном или обоих игровых полях. Вы должны зачеркнуть столько номеров,
            сколько обозначили в предыдущем разделе "1". 
            На каждом игровом поле Вы можете выбрать отдельную комбинацию номеров (игровой вариант). 
            Если Вы не хотите сами выбирать номера, то зачеркните отметку [АВТО] (она находится после 80-го номера),
            и компьютер сам выберет для Вас случайную комбинацию. 
            Каждое игровое поле (А и Б) играет отдельно друг от друга.`},

    {id: 3,
     headline: "Карточка: размер Вашей ставки",
     text: `Вы можете увеличить ставку от 2-х до 10 раз. Зачеркните в разделе "3",
            во сколько раз вы увеличиваете Вашу ставку, во столько же раз увеличится и Ваш выигрыш.
            Если вы не хотите увеличивать Вашу ставку, ничего зачеркивать в этом разделе не требуется. 
            Обратите внимание! На билете будет указана ЦЕНА вашей ставки в грн. 
            ("Ставка") равной цене базовой ставки 10 YUSRA., умноженной на коэффициент увеличения ставки. 
            При определении выигрыша, нужно взять размер приза из таблицы выигрышей и умножить его на коэффициент
            увеличения (а не на ЦЕНУ ставки, указанную в YUSRA).`},

    {id: 4,
     headline: "Карточка: размер Вашей ставки",
     text: `Вы можете принять участие в одном или в нескольких последовательных розыгрышах.
            Максимальное количество последовательных розыгрышей — 14.
            Зачеркните количество розыгрышей внизу игровой карточки.
            Если Вы хотите принять участие только в одном розыгрыше, то зачеркивать количество розыгрышей не нужно. 
            Помните, что стоимость билета зависит от количества розыгрышей. 
            Например, если Вы выбрали два игровых варианта для участия в 5 розыгрышах, 
            то Ваш билет будет стоить 2 х 5 x 10 = 100 YUSRA.`},
        ]